
const title = '积加ERP - 数据更全的亚马逊ERP系统';

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
